<template>
    <div
        class="c-tab"
        :class="[activeTab === data.value && 'active']"
        @click="onChangeTab"
    >
        {{ data.label }}
    </div>
</template>

<script>
export default {
    name: 'TabItem',
    props: {
        data: {
            type: Object,
        },
        activeTab: {
            type: Number,
        },
    },
    methods: {
        onChangeTab() {
            this.$emit('handleChangeTab', this.data.value);
        },
    },
};
</script>

<style lang="scss" scoped>
.c-tab {
    height: 50px;
    width: 113px;
    background-color: #dfdfe0;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 18px;
    font-weight: 600;
    color: #7c7c7a;
    cursor: pointer;

    &:not(:last-child) {
        border-right: 1px solid #e3e7e9;
    }

    &.active {
        opacity: 1;
        color: #41b8dc;
        background: #D9D9D9;
    }
}
</style>
